import { useNavigate } from 'react-router';
import { Typography } from '@/components/Typography/Typography';
import { ButtonNew } from '@/components-new/ButtonNew/ButtonNew';
import { getMyVaultPath } from '@/bundle/_OrgAdmin/pages/MyVaultPage/path/path';
import { DashboardSummaryType } from '@/types/dashboardTypes';
import { CardActions, CardHead, CardsGrid, SummaryCard } from '../styles';
import { StatusWrapper } from '@/components/StatusWrapper/StatusWrapper';
import { STATUS_VARIANT_HIGHLIGHT } from '@/components/StatusWrapper/const';

export const SummaryCards = ({ summary }: { summary?: DashboardSummaryType }) => {
  const navigate = useNavigate();
  const vault = summary?.my_vault;
  const vaultLine = vault?.accounts
    ? vault.regions.map((r) => `${r.label} (${r.count})`).join(' · ')
    : 'No accounts yet. Add the account payers should send money to.';

  return (
    <CardsGrid>
      <SummaryCard>
        <CardHead>
          <Typography fontWeight='semibold'>My Vault</Typography>
          <StatusWrapper variant={STATUS_VARIANT_HIGHLIGHT.GREEN}>{vault?.accounts ?? 0} accounts</StatusWrapper>
        </CardHead>
        <Typography variant='bodySmall'>{vaultLine}</Typography>
        <CardActions>
          <ButtonNew size='medium' variant='secondary' onClick={() => navigate(getMyVaultPath())}>
            Open My Vault
          </ButtonNew>
          <ButtonNew size='medium' variant='secondary' onClick={() => navigate(`${getMyVaultPath()}?create=1`)}>
            Add account
          </ButtonNew>
        </CardActions>
      </SummaryCard>

      <SummaryCard>
        <CardHead>
          <Typography fontWeight='semibold'>Insured transactions</Typography>
          <StatusWrapper variant={STATUS_VARIANT_HIGHLIGHT.GREY}>
            {summary?.insured.available ? summary.insured.status : 'Coming soon'}
          </StatusWrapper>
        </CardHead>
        <Typography variant='bodySmall'>{summary?.insured.summary}</Typography>
        <CardActions>
          <ButtonNew size='medium' variant='secondary' disabled={!summary?.insured.available}>
            Open
          </ButtonNew>
        </CardActions>
      </SummaryCard>

      <SummaryCard>
        <CardHead>
          <Typography fontWeight='semibold'>My ACH</Typography>
          <StatusWrapper variant={STATUS_VARIANT_HIGHLIGHT.GREY}>
            {summary?.ach.available ? summary.ach.status : 'Coming soon'}
          </StatusWrapper>
        </CardHead>
        <Typography variant='bodySmall'>{summary?.ach.summary}</Typography>
        <CardActions>
          <ButtonNew size='medium' variant='secondary' disabled={!summary?.ach.available}>
            Enable My ACH
          </ButtonNew>
        </CardActions>
      </SummaryCard>
    </CardsGrid>
  );
};
